import React from "react";
import { AiFillEye } from "react-icons/ai";
import { HiTrash } from "react-icons/hi";
import { IoMdDownload } from "react-icons/io";
import ApiConfig from "../../config/ApiConfig";
import PdfSvg from "../../svg/Notepdf.svg";

function AttachmentShowNotes({ props, setNoteData, appointmentId }) {
  // console.log(props);
  // const download = (attach) => {
  //   // Split image name
  //   const nameSplit = attach.split("/");
  //   const duplicateName = nameSplit.pop();

  //   const typeSplit = attach.split(".");
  //   const duplicateType = typeSplit.pop();
  //   console.log(attach);

  //   const url = window.URL.createObjectURL(
  //     new Blob([props?.data?.file?.video[0]])
  //   );
  //   const link = document.createElement("a");
  //   link.href = url;
  //   link.setAttribute("download", duplicateName); // Set the desired file name
  //   console.log(url);
  //   // element.download = duplicateName;
  //   document.body.appendChild(link);
  //   link.click();
  //   // element.click();
  // };

  const handleDownload = (url, name) => {
    fetch(url)
      .then((response) => response.blob())
      .then((blob) => {
        const url = window.URL.createObjectURL(new Blob([blob]));
        const a = document.createElement("a");
        a.style.display = "none";
        a.href = url;
        a.download = name; // Change the filename as needed
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
      })
      .catch((error) => {
        console.error("Error downloading attachment:", error);
      });
  };

  return (
    <div
      className=" d-flex rounded mb-2"
      style={{
        height: "50px",
        color: "black",
        width: "100%",
        // border: "1px solid rgba(21, 101, 99, 1)",
        backgroundColor: "rgba(247, 247, 247, 1)",
      }}
    >
      <div
        className="me-3 d-flex justify-content-between align-items-center"
        style={{
          position: "relative",
          width: "100%",
          left: "5px",
          cursor: "pointer",
        }}
      >
        <div
          style={{
            width: "70%",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            overflow: "hidden",
          }}
          className=""
        >
          {props?.document !== "" && props.document[0]?.name && (
            <img src={PdfSvg} alt="" className="ms-2 me-4" />
          )}

          {Array.isArray(props?.document)
            ? props.document[0]?.name
            : props?.document}
          {Array.isArray(props?.video) ? props.video[0]?.name : props?.video}
          {Array.isArray(props?.image) ? props.image[0]?.name : props?.image}
        </div>
        <div
          className="pointer d-flex justify-content-center align-items-center gap-3 pe-2"
          style={{ position: "absolute", top: "0", right: "0", height: "50px" }}
        >
          {Array.isArray(props?.image) ? (
            <a
              className="text-decoration-none text-black d-flex align-items-center"
              href={URL.createObjectURL(props.image[0])}
              rel="noreferrer"
              target="_top"
              download={props.image[0]?.name}
            >
              <IoMdDownload />
            </a>
          ) : (
            props?.image && (
              <IoMdDownload
                onClick={() =>
                  handleDownload(
                    `${ApiConfig.ImageUrl}appoinment/image/${appointmentId}/${props?.image}`,
                    props?.image
                  )
                }
              />
            )
          )}

          {Array.isArray(props?.video) ? (
            <a
              className="text-decoration-none text-black d-flex align-items-center"
              href={URL.createObjectURL(props.video[0])}
              rel="noreferrer"
              target="_top"
              download={props.video[0]?.name}
            >
              <IoMdDownload />
            </a>
          ) : (
            props?.video && (
              <IoMdDownload
                onClick={() =>
                  handleDownload(
                    `${ApiConfig.ImageUrl}appoinment/documents/${appointmentId}/${props?.video}`,
                    props?.video
                  )
                }
              />
            )
          )}

          {Array.isArray(props?.document) ? (
            <a
              className="text-decoration-none text-black d-flex align-items-center"
              href={URL.createObjectURL(props.document[0])}
              rel="noreferrer"
              target="_top"
              download={props.document[0]?.name}
            >
              <IoMdDownload />
            </a>
          ) : (
            props?.document && (
              <IoMdDownload
                onClick={() =>
                  handleDownload(
                    `${ApiConfig.ImageUrl}appoinment/documents/${appointmentId}/${props?.document}`,
                    props?.document
                  )
                }
              />
            )
          )}

          {Array.isArray(props?.image) ? (
            <a
              className="text-decoration-none text-black d-flex align-items-center "
              href={URL.createObjectURL(props.image[0])}
              target="_blank"
              rel="noreferrer"
            >
              <AiFillEye />
            </a>
          ) : (
            props?.image && (
              <a
                className="text-decoration-none text-black d-flex align-items-center "
                href={`${ApiConfig.ImageUrl}appoinment/image/${appointmentId}/${props?.image}`}
                target="_blank"
                // rel="noreferrer"
              >
                <AiFillEye />
              </a>
            )
          )}

          {Array.isArray(props?.video) ? (
            <a
              className="text-decoration-none text-black d-flex align-items-center "
              href={URL.createObjectURL(props.video[0])}
              target="_blank"
              rel="noreferrer"
            >
              <AiFillEye />
            </a>
          ) : (
            props?.video && (
              <a
                className="text-decoration-none text-black d-flex align-items-center "
                href={`${ApiConfig.ImageUrl}appoinment/documents/${appointmentId}/${props?.video}`}
                target="_blank"
                rel="noreferrer"
              >
                <AiFillEye />
              </a>
            )
          )}

          {Array.isArray(props?.document) ? (
            <a
              className="text-decoration-none text-black d-flex align-items-center "
              href={URL.createObjectURL(props.document[0])}
              target="_blank"
              rel="noreferrer"
            >
              <AiFillEye />
            </a>
          ) : (
            props?.document && (
              <a
                className="text-decoration-none text-black d-flex align-items-center "
                href={`${ApiConfig.ImageUrl}appoinment/documents/${appointmentId}/${props?.document}`}
                target="_blank"
                rel="noreferrer"
              >
                <AiFillEye />
              </a>
            )
          )}

          <HiTrash
            onClick={() => {
              setNoteData({
                ...props,
                document: "",
                video: "",
                image: "",
              });
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default AttachmentShowNotes;
